import { css } from 'lit'
import { csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const slideInStyle = css`  
  .button-icon {
    height: 18px;
    width: 18px;
  }
  
  .icon {
    display: inline-flex;
    width: 42px;
    height: 42px; 
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 100px;
    color: ${csColorText.white};
    background-color: ${csColorFunctional.info};
  }
  
  .border {
    border: 1px solid white;
    height: 22px;
    width: 22px;
    border-radius: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  cse-slide-in {
    --cse-text-text-align: center;
  }
  
  csc-basket-creator, csc-basket-editor, csc-basket-transfer-form {
    width: 100%;
  }
`
